var map = {
	"./Beer1.png": 8089,
	"./Beer2.png": 2946,
	"./Bitmap.png": 7453,
	"./CloudUpload.svg": 1398,
	"./CreditNote-TableIcon.svg": 5333,
	"./CreditNoteIcon.svg": 5418,
	"./DatePickerNewLedger.svg": 6585,
	"./Delete.svg": 9399,
	"./DownloadTransactionSummaryIcon.svg": 2677,
	"./EditInvoice-icon.svg": 4931,
	"./PersonIcon.svg": 2538,
	"./SearchIcon.svg": 4453,
	"./Stroller.svg": 2659,
	"./X.svg": 1770,
	"./arrow-left.svg": 8609,
	"./bud_light.png": 4502,
	"./cancel.svg": 3328,
	"./checkBox_check.svg": 5304,
	"./close-eye-icon.svg": 6620,
	"./crossIcon.png.png": 78,
	"./customerNavbarIcons/BellIcon-Highlighted.svg": 3677,
	"./customerNavbarIcons/BellIcon.svg": 7017,
	"./customerNavbarIcons/accountIcon.svg": 8573,
	"./customerNavbarIcons/ledger.svg": 5786,
	"./customerNavbarIcons/prebook.svg": 2607,
	"./customerNavbarIcons/shopIcon.svg": 4646,
	"./customerSortByIcon.svg": 8470,
	"./dashboard/NoDataFound.svg": 1208,
	"./dashboard/globalFilters/ChannelTypeIcon.svg": 2518,
	"./dashboard/globalFilters/FromDateIcon.svg": 3559,
	"./dashboard/globalFilters/LicenseTypeIcon.svg": 9006,
	"./dashboard/globalFilters/PincodeIcon.svg": 4769,
	"./dashboard/globalFilters/ToDateIcon.svg": 9608,
	"./deleteIcon.png": 7450,
	"./deleteIcon.svg": 5368,
	"./delivered.svg": 2642,
	"./disptched.svg": 6152,
	"./download-cloud-02.svg": 4641,
	"./download-icon.png": 9384,
	"./download-ledgerIcon-cp.svg": 7489,
	"./downloadNoBG.svg": 5206,
	"./drop-down.svg": 3394,
	"./edit-icon.svg": 3012,
	"./edit-pencil-icon.png": 7056,
	"./emptyWishlistIcon.svg": 6563,
	"./emptycartIcon.svg": 1964,
	"./favIcon.svg": 4462,
	"./filter-lines.svg": 2794,
	"./glass-cold-beer.png": 680,
	"./glass-cold-beer1.png": 1923,
	"./glass-cold-beer2.png": 6312,
	"./glass-cold-beer3.png": 7441,
	"./glass-cold-beer4.png": 8958,
	"./helpandSupportIcons/delieveryBus.svg": 6451,
	"./helpandSupportIcons/deliveryTimeline.svg": 3147,
	"./helpandSupportIcons/helpandSupportIcons.svg": 819,
	"./helpandSupportIcons/orderQuantity.svg": 4913,
	"./helpandSupportIcons/orderReturn.svg": 1044,
	"./helpandSupportIcons/sealed.svg": 4026,
	"./helpandSupportIcons/timeLine.svg": 8339,
	"./helpandSupportIcons/wallet.svg": 857,
	"./homePage/HeroBackground.jpg": 7309,
	"./homePage/ProductBackground1.png": 4067,
	"./homePage/ProductBackground2.png": 7208,
	"./homePage/ProductBackground3.png": 1073,
	"./homePage/arrowright.svg": 1254,
	"./homePage/beer-brew-machine.png": 9590,
	"./homePage/beer-filling-glass-new.jpg": 6059,
	"./homePage/cart-icon.svg": 5059,
	"./homePage/drop-profile.svg": 9434,
	"./homePage/ledgers.svg": 2385,
	"./homePage/manage-orders.svg": 2582,
	"./homePage/productImages/1.png": 9850,
	"./homePage/productImages/2.png": 433,
	"./homePage/productImages/3.png": 2952,
	"./homePage/productImages/4.png": 1943,
	"./homePage/productImages/5.png": 2718,
	"./homePage/productImages/6.png": 6725,
	"./homePage/productImages/7.png": 3836,
	"./homePage/productImages/8.png": 9675,
	"./homePage/profilee-icon.svg": 1149,
	"./homePage/search-icon.svg": 7037,
	"./icons/file-add.svg": 9175,
	"./icons/green-tick-upload.svg": 2984,
	"./icons/orange-back-arrow.svg": 1427,
	"./icons/payment-success-popup-icon.svg": 9974,
	"./icons/white-truck-icon.svg": 565,
	"./images/BG4.png": 4436,
	"./images/GreenTick.png": 9229,
	"./images/LoginBG.png": 7649,
	"./images/bevera-logo.png": 4862,
	"./landingPage/bestPrices-icon.svg": 493,
	"./landingPage/callUs-icon.svg": 7957,
	"./landingPage/customerSupport-icon.svg": 9432,
	"./landingPage/email-icon.svg": 1087,
	"./landingPage/emailSentTick-icon.svg": 832,
	"./landingPage/errorToast-icon.svg": 5400,
	"./landingPage/explore-icon.svg": 2708,
	"./landingPage/freeShipping-icon.svg": 9865,
	"./landingPage/mailUs-icon.svg": 3178,
	"./landingPage/moneyGuarantee-icon.svg": 331,
	"./landingPage/password-icon.svg": 1992,
	"./landingPage/successToast-icon.svg": 1935,
	"./latest-icon.svg": 8199,
	"./leftArrow.svg": 1996,
	"./modal-closing-icon.png": 4205,
	"./myOrders/NoOrders.svg": 8964,
	"./myOrdersIcon.png": 1410,
	"./new.svg": 7932,
	"./notifications/NotificationSoundIcon.svg": 3190,
	"./oldest-icon.svg": 3271,
	"./open-eye-icon.jpg": 460,
	"./orderStatusIcons/delivered.svg": 3279,
	"./orderStatusIcons/dispatched.svg": 4868,
	"./orderStatusIcons/processingIcon.svg": 5503,
	"./orderStatusIcons/readyToDispatch.svg": 9499,
	"./outlets.svg": 9892,
	"./passcheck-cross.svg": 2704,
	"./passcheck-tick.svg": 6415,
	"./pencil-icon.svg": 8345,
	"./processing-icon.svg": 9415,
	"./productCard/edit-icon1.svg": 8543,
	"./productCard/info.svg": 9816,
	"./ready-to-dispatch.svg": 9606,
	"./sad-emoji.svg": 3139,
	"./sellerNavbarIcons/ProfileIcon_SellerNavbar.svg": 9660,
	"./sellerNavbarIcons/analytics.svg": 6428,
	"./sellerNavbarIcons/arrowDown.svg": 175,
	"./sellerNavbarIcons/catalog.svg": 2025,
	"./sellerNavbarIcons/customers.svg": 2479,
	"./sellerNavbarIcons/feedback.svg": 9577,
	"./sellerNavbarIcons/inventory.svg": 4464,
	"./sellerNavbarIcons/logout.svg": 7510,
	"./sellerNavbarIcons/orders.svg": 7383,
	"./sellerNavbarIcons/prebookings.svg": 4059,
	"./sellerNavbarIcons/receipt.svg": 8424,
	"./sellerNavbarIcons/rupeeIcon.svg": 428,
	"./sellerNavbarIcons/salesRepManagement.svg": 1012,
	"./sellerNavbarIcons/shipment.svg": 522,
	"./sellerNavbarIcons/userManagement.svg": 4028,
	"./stages/approved.svg": 9067,
	"./stages/delivered.svg": 9654,
	"./stages/dispatched.svg": 9115,
	"./stages/new.svg": 2624,
	"./stages/processing.svg": 3287,
	"./stages/readyfordispatch.svg": 4878,
	"./visibility.svg": 7273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;